/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".extent{box-shadow:0 1px 2px rgba(0,0,0,.3)}.extent.vertical{max-width:63px}.extent>.btn-grouped+.btn-grouped{margin-left:0}.extent>.btn>.svg-icon{height:auto;width:auto}.extent>.btn.icon-ui-flush>.svg-icon{padding-right:0}.extent>.btn.icon-ui-flush{padding:4px 7.5px}.extent>.btn.icon-ui-flush.isSvg{padding:1px}"];
export { styles as styles };
